import React, { useState, useEffect } from 'react';
import { Box, List, ListItemButton, Collapse } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import {
  DataSetIcon,
  HomeIcon,
  LogoutIcon,
  ModelIcon,
  ChainIcon,
  EvaluateIcon,
} from '../../Icons/Icons';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import userHook from 'hooks/userHook';
import { logout } from "authorization/AuthorizationProvider";

const Navigation = () => {
  const { pathname } = useLocation();
  const [isDatasetOpen, setIsDatasetOpen] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isEvaluateOpen, setIsEvaluateOpen] = useState(false);

  const { isAdmin, isClient, loading } = userHook();

  const onLogout = () => {
    logout();
  };

  useEffect(() => {
    setIsDatasetOpen(pathname.includes('dataset'));
    setIsModelOpen(pathname.includes('model'));
    setIsEvaluateOpen(pathname.includes('evaluate'));
  }, [pathname]);

  const handleDatasetClick = () => {
    setIsDatasetOpen((prev) => !prev);
    setIsModelOpen(false);
    setIsEvaluateOpen(false);
  };

  const handleModelClick = () => {
    setIsModelOpen((prev) => !prev);
    setIsDatasetOpen(false);
    setIsEvaluateOpen(false);
  };

  const handleEvaluateClick = () => {
    setIsEvaluateOpen((prev) => !prev);
    setIsDatasetOpen(false);
    setIsModelOpen(false);
  };

  const renderNavLink = (to: string, icon: React.ReactNode, text: string, onClick?: () => void, end: boolean = false) => (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => isActive || (pathname.includes(to) && to !== '/') ? 'active' : ''}
      onClick={onClick}
    >
      {icon}
      <span>{text}</span>
    </NavLink>
  );

  return (
    <Box className="navigation-wrapper">
      <div className="navigation">
        <List component="nav" className="top-nav">
          <ListItemButton disableRipple>
            {renderNavLink('/', <HomeIcon />, 'Home')}
          </ListItemButton>
          {!loading && isAdmin && (
            <>
              <ListItemButton disableRipple onClick={handleDatasetClick}>
                {renderNavLink('/datasets', <DataSetIcon />, 'Data', undefined, true)}
              </ListItemButton>
              <Collapse in={isDatasetOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton disableRipple sx={{ pl: 4 }}>
                    {renderNavLink('/dataset/locators/1', null, 'Locators')}
                  </ListItemButton>
                  <ListItemButton disableRipple sx={{ pl: 4 }}>
                    {renderNavLink('/dataset/screws/1', null, 'Screws')}
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItemButton disableRipple onClick={handleModelClick}>
                {renderNavLink('/models', <ModelIcon />, 'Models', undefined, true)}
              </ListItemButton>
              <Collapse in={isModelOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton disableRipple sx={{ pl: 4 }}>
                    {renderNavLink('/model/locators', null, 'Locators')}
                  </ListItemButton>
                  <ListItemButton disableRipple sx={{ pl: 4 }}>
                    {renderNavLink('/model/screws', null, 'Screws')}
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItemButton disableRipple onClick={handleEvaluateClick}>
                {renderNavLink('/evaluate', <EvaluateIcon />, 'Evaluate', undefined, true)}
              </ListItemButton>
              <Collapse in={isEvaluateOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton disableRipple sx={{ pl: 4 }}>
                    {renderNavLink('/evaluate/locators', null, 'Locators')}
                  </ListItemButton>
                  <ListItemButton disableRipple sx={{ pl: 4 }}>
                    {renderNavLink('/evaluate/screws', null, 'Screws')}
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItemButton disableRipple>
                {renderNavLink('/customers', <PeopleOutlineIcon />, 'Customers')}
              </ListItemButton>
            </>
          )}
          {!loading && isClient && (
            <>
              <ListItemButton disableRipple>
                {renderNavLink('/predict/locators', <ChainIcon />, 'Predict Locators')}
              </ListItemButton>
              <ListItemButton disableRipple>
                {renderNavLink('/predict/screws', <ChainIcon />, 'Predict Screws')}
              </ListItemButton>
            </>
          )}
        </List>

        <List component="nav" className="bottom-nav">
          <ListItemButton onClick={onLogout} disableRipple>
            {renderNavLink('/logout', <LogoutIcon />, 'Log out')}
          </ListItemButton>
        </List>
      </div>
    </Box>
  );
};

export default Navigation;
